import PropTypes from 'prop-types';

import CargillWhite from './CargillWhite';

import './styles/index.css';

const CargillLogo = ({ homePageUrl }) => (
  <a className="header-cargill-logo" href={homePageUrl} aria-label="Go to dashboard">
    <CargillWhite />
  </a>
);

CargillLogo.propTypes = {
  homePageUrl: PropTypes.string.isRequired
};

export default CargillLogo;
